import { Stack, Typography, Paper, Divider, Button, Box } from '@mui/material';
import React from 'react';
import DateRangeOutlinedIcon from '@mui/icons-material/DateRangeOutlined';
import ArrowBackOutlinedIcon from '@mui/icons-material/ArrowBackOutlined';
import ArrowForwardOutlinedIcon from '@mui/icons-material/ArrowForwardOutlined';
import PeopleOutlinedIcon from '@mui/icons-material/PeopleOutlined';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import { KoriHintarivit } from '@/components/Hintarivit';

const Perustiedot = ({ data, onEditNimi }) => {
  const { t } = useTranslation();

  return (
    <Paper sx={{ marginTop: '1em', p: '0.5em' }}>
      <Stack divider={<Divider />} spacing={1}>
        <Stack direction="row" alignItems="center" spacing={2}>
          <DateRangeOutlinedIcon />
          <Typography sx={{ flex: 1 }}>
            {t('perustiedot.reservationTime')}
          </Typography>
          <Typography
            sx={{
              minWidth: 0,
              textAlign: 'right',
              flexShrink: 1,
              maxWidth: '50%',
            }}
          >
            {(data.varausAlkaa && data.varausLoppuu) ? `${dayjs(data.varausAlkaa).format('DD.MM.YY')} - ${dayjs(data.varausLoppuu).format('DD.MM.YY')}` : 'Ei varausta'}
          </Typography>
        </Stack>
        <Stack direction="row" alignItems="center" spacing={2}>
          <ArrowBackOutlinedIcon />
          <Typography sx={{ flex: 1 }}>
            {t('perustiedot.startDate')}
          </Typography>
          <Typography>
            {(data.varausAlkaa) ? dayjs(data.varausAlkaa).format('HH:mm') : 'Ei varausta'}
          </Typography>
        </Stack>
        <Stack direction="row" alignItems="center" spacing={2}>
          <ArrowForwardOutlinedIcon />
          <Typography sx={{ flex: 1 }}>
            {t('perustiedot.endDate')}
          </Typography>
          <Typography>
            {(data.varausLoppuu) ? dayjs(data.varausLoppuu).format('HH:mm') : 'Ei varausta'}
          </Typography>
        </Stack>
        <Stack direction="row" alignItems="center" spacing={2}>
          <PeopleOutlinedIcon />
          <Typography sx={{ flex: 1 }}>
            {t('perustiedot.personAmount')}
          </Typography>
          <Typography>
            {(data.tuotteet.henkiloTotal) ? data.tuotteet.henkiloTotal : 'Ei varausta'}
          </Typography>
        </Stack>
        <KoriHintarivit laskutustiedot={data.laskutustiedot} tuotteet={data.tuotteet} />
      </Stack>
      <Box sx={{ width: '100%', mt: 2 }}>
        <Button variant="outlined" size="small" onClick={onEditNimi}>
          {t('perustiedot.editName')}
        </Button>
      </Box>
    </Paper>
  );
};

export default Perustiedot;
